package one.healthium.profile.ui.food.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Modifier
import com.slapps.cupertino.ExperimentalCupertinoApi
import kotlinx.datetime.TimeZone
import kotlinx.datetime.offsetIn
import one.healthium.base.utils.toLocalDateTime
import one.healthium.ui.compose.components.cupertino.CupertinoDateTimePicker
import one.healthium.ui.compose.components.cupertino.rememberCupertinoDateTimePickerState
import kotlin.time.Duration.Companion.seconds
import kotlin.time.Instant

@OptIn(ExperimentalCupertinoApi::class)
@Composable
fun DatePicker(
    modifier: Modifier = Modifier,
    date: Instant,
    onValueChanged: (Instant) -> Unit,
) {
    val state = rememberCupertinoDateTimePickerState(
        initialSelectedDateMillis = date.toEpochMilliseconds(),
        initialHour = date.toLocalDateTime().hour,
        initialMinute = date.toLocalDateTime().minute,
    )
    LaunchedEffect(state.selectedDateTimeMillis) {
        val instant = Instant.fromEpochMilliseconds(state.selectedDateTimeMillis)
        val timeZoneOffset = instant.offsetIn(TimeZone.currentSystemDefault()).totalSeconds
        val utcInstant = instant.minus(timeZoneOffset.seconds) // Adjust for timezone offset
        onValueChanged(utcInstant)
    }
    CupertinoDateTimePicker(
        modifier = modifier,
        state = state,
    )
}